import { PulseConfigurations } from '../configuration';

const host = resolveHostname();

let _modernity: 'modern' | 'compat' | null = null;

export function loadAutopilotSDK(config: Partial<PulseConfigurations>): void {
    (window as any).autopilot = (window as any).autopilot || {};
    (window as any).autopilotOptions = (window as any).autopilotOptions || {};

    if (config?.autopilotTracking?.enabled === true && !scriptAlreadyExists()) {
        addScript(config);
    }
}

function scriptAlreadyExists(): boolean {
    const scripts = document.querySelectorAll<HTMLScriptElement>('script[src]');

    return Array.from(scripts).some((script) => {
        const src = script.src;

        return src.includes('ap-worker') && src.includes('ap/web');
    });
}

function addScript(config: Partial<PulseConfigurations>): void {
    if (!config?.app) {
        console.error('Autopilot: missing app property in config');

        return;
    }

    const modern = browserModernity();
    const baseURL = `${host}/ap/web/v1/sdk/${config.app}`;
    const ap = ((window as any).autopilot = (window as any).autopilot || {});
    const autopilotOptions = (window as any).autopilotOptions || {};
    const queryString = 'c=' + encodeURIComponent(JSON.stringify(autopilotOptions));

    const script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.type = modern === 'modern' ? 'module' : 'text/javascript';
    script.onerror = (e) => {
        console.error('Autopilot: failed to load script', e);
    };
    script.src = `${baseURL}/ap.${modern}.js?${queryString}`;

    if (ap.__) {
        console.warn(`Autopilot already loaded!`);

        return;
    }

    const internals = {
        q: [],
        c: { ...config },
        idu: window.location.href,
        t: Date.now(),
        v: '0.0.1',
        b: baseURL,
        m: modern,
    };
    ap.__ = internals;
    document.head.prepend(script);
}

function browserModernity(): 'modern' | 'compat' {
    if (_modernity) {
        return _modernity;
    }

    try {
        const a = new (ArrayBuffer as any)(8, { maxByteLength: 16 });
        a.resize(16);
        const script = document.createElement('script');

        const isModern =
            typeof (URL as any).canParse === 'function' &&
            window.ArrayBuffer &&
            Boolean(a.resizable) &&
            a.byteLength === 16 &&
            typeof script.noModule === 'boolean';

        _modernity = isModern ? 'modern' : 'compat';
    } catch {
        _modernity = 'compat';
    }

    return _modernity;
}

function resolveHostname(): string {
    const host = globalThis?.location?.host;

    if (/(localhost|127\.0\.0\.1):9000/.test(host)) {
        // Local development of the SDK
        return 'https://ap-worker-dev.picsart-8821.workers.dev';
    }

    if (
        /pulse-react-demo\.stage\.picsart\.tools/.test(host) ||
        /dev-portal\.picsart\.tools/.test(host) ||
        /localhost:3000/.test(host)
    ) {
        // Development
        return 'https://ap-worker-stage.picsart-8821.workers.dev';
    }

    if (
        /([^.]+\.)*picsartstage2\.com/.test(host) ||
        /([^.]+\.)+sdk\.picsart\.io/.test(host) ||
        /([^.]+\.)+admaker\.pages\.dev(:\d+)?/.test(host) ||
        /^https?:\/\/tools-preprod\.picsart\.com(:\d+)?/i.test(host) ||
        /localhost/.test(host) ||
        /127\.0\.0\.1/.test(host)
    ) {
        // Staging
        return 'https://ap-worker-stage.picsart-8821.workers.dev';
    }

    // Production
    return 'https://ap-worker.optifyr.com';
}
